import {
  Datatype,
  IReference,
  IReferencePath,
  ReferenceType,
} from '@framework/engine';
import { IProvinceWidget } from './IProvinceWidget';

export function getProvinceWidgetReference(
  path: IReferencePath,
  widget: IProvinceWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    widgetType: widget.type,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      type: Datatype.Hidden,
    },
  };
}
